import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-hamburger-menu-icon',
  templateUrl: './hamburger-menu-icon.component.html',
  styleUrls: ['./hamburger-menu-icon.component.less']
})
export class HamburgerMenuIconComponent implements OnInit {

  dropdown = false;
  toggleMenuClicked = false;
  @Input() listMenu: string[] = [];
  @Output() menuChoice = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
  }

  onClickOutside(event: any) {
    if (this.dropdown && !this.toggleMenuClicked) {
      this.dropdown = false;
    }
    this.toggleMenuClicked = false;
  }

  toggleDropdown() {
    this.toggleMenuClicked = true;
    this.dropdown = !this.dropdown;
  }

  onClicked(choosedMenu: string) {
    this.menuChoice.emit(choosedMenu);
    this.dropdown = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/cut/hamburger-menu/hamburger-menu-icon.component.ts